import { createApp } from 'vue'
import router from '../routes/index'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueLoading from 'vue-loading-overlay'
import Adjust from '@adjustcom/adjust-web-sdk'
import "./assets/reset.css"
import toast from '@/components/common/toast.js'
import App from '@/App.vue'
import './registerServiceWorker'
import store from '../store/index'
// import { initializeApp } from 'firebase/app'
// import { getAnalytics } from 'firebase/analytics'

// const firebaseConfig = {
//     apiKey: "AIzaSyCQhsx2H4vRVD0jdBryAZwpzPZrdkqVkP0",
//     authDomain: "credit-char-h5.firebaseapp.com",
//     projectId: "credit-char-h5",
//     storageBucket: "credit-char-h5.appspot.com",
//     messagingSenderId: "795532969479",
//     appId: "1:795532969479:web:07af63d6797e47a4c1cca2",
//     measurementId: "G-QLEJL16NRW"
// };

// const app2 = initializeApp(firebaseConfig);
// getAnalytics(app2);
// Adjust.initSdk({
// appToken: 'kjm6ivz1y2gw',
// environment: 'production'
// });  
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
let adjust_referrer = getParameterByName("adjust_referrer")
try {
    Adjust.setReferrer(encodeURIComponent(`${adjust_referrer}`)) 
    // console.log(adjust_referrer)  
} catch (error) {
    console.log(error)
}

store.dispatch("fetchConfig")
let app = createApp(App)
app.config.globalProperties.$toast = toast
app.use(router).use(store).use(VueLoading)
app.provide('$toast', toast)
app.mount('#app')